import { render, staticRenderFns } from "./OrderTransactionStripeDetail.vue?vue&type=template&id=37e86887"
import script from "./OrderTransactionStripeDetail.vue?vue&type=script&lang=js"
export * from "./OrderTransactionStripeDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderTransactionStripeDetail.vue?vue&type=style&index=0&id=37e86887&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports